import React from 'react'
import { H2, P }  from 'modules/common/components/elements'
import { Link } from 'react-router-dom'

const CourseDetails = ({name, address, id, txt='OPEN CLUB PAGE'}) => (
  <div>
    <H2
      textDark
      halfMarginBottom
    >{name}</H2>
    <P
      halfMarginTop
    >
      {address}
    </P>
    {
      txt && (
        <P>
          <Link className="btn btn--ghost" to={`/courses/${id}`}>{txt}</Link>
        </P>
      )
    }
  </div>
)

export default CourseDetails



// WEBPACK FOOTER //
// ./src/modules/pros/components/CourseDetails.js